/** CMS URL for the live feed listing (Subscribe CTA, post–sign-out redirect). */
export const LIVE_FEEDS_PAGE_PATH = "/live-feeds";

/** CMS URL for the Dartfish TV product listing. */
export const DARTFISH_PAGE_PATH = "/media/adelaide-footy-tv";

export const POST_LOGOUT_REDIRECT_PATH = LIVE_FEEDS_PAGE_PATH;
